const news = {
    en: {
        "news.title": "News",
        "news.addNews": "Add News",
        "news.modifyNews": "Modify News",
        "news.newsTitle": "Title",
        "news.publisher": "Publisher",
        "news.priority": "Priority",
        "news.created": "Created",
        "news.modified": "Modified",
        "news.message": "Message",
        "news.enterTitle": "Enter title",
        "news.enterMessage": "Enter message",
        "news.selectPriority": "Select priority",
        "news.prLow": "Low",
        "news.prMedium": "Medium",
        "news.prHigh": "High",
        "news.publish": "Publish",
        "news.removeNews": "Remove news",
        "news.removeConfirm": "Do you want to remove this news item?",
    },
    ru: {
        "news.title": "Новости",
        "news.addNews": "Добавить новость",
        "news.modifyNews": "Изменить новость",
        "news.newsTitle": "Заголовок",
        "news.publisher": "Издатель",
        "news.priority": "Приоритет",
        "news.created": "Создано",
        "news.modified": "Изменено",
        "news.message": "Сообщение",
        "news.enterTitle": "Введите заголовок",
        "news.enterMessage": "Введите сообщение",
        "news.selectPriority": "Выберите приоритет",
        "news.prLow": "Низкий",
        "news.prMedium": "Средний",
        "news.prHigh": "Высокий",
        "news.publish": "Опубликовать",
        "news.removeNews": "Удалить новость",
        "news.removeConfirm": "Вы хотите удалить эту новость?",
    },
    geo: {
        "news.title": "სიახლეები",
        "news.addNews": "სიახლის დამატება",
        "news.modifyNews": "სიახლის რედაქტირება",
        "news.newsTitle": "სათაური",
        "news.publisher": "გამომქვეყნებელი",
        "news.priority": "პრიორიტეტი",
        "news.created": "შექმნილია",
        "news.modified": "შეცვლილია",
        "news.message": "შეტყობინება",
        "news.enterTitle": "შეიყვანეთ სათაური",
        "news.enterMessage": "შეიყვანეთ შეტყობინება",
        "news.selectPriority": "აირჩიეთ პრიორიტეტი",
        "news.prLow": "დაბალი",
        "news.prMedium": "საშუალო",
        "news.prHigh": "მაღალი",
        "news.publish": "გამოქვეყნება",
        "news.removeNews": "სიახლის წაშლა",
        "news.removeConfirm": "გსურთ ამ სიახლის წაშლა?",
    },
};

export default news;
